<template>
  <div class="empty-state text-center py-5" role="status">
    <div class="empty-icon mb-3">
      <b-icon :icon="icon" font-scale="3" style="color: var(--text-muted);"/>
    </div>
    <h4 class="mb-2" style="color: var(--text-foreground);">{{ title }}</h4>
    <p class="mb-3" style="color: var(--text-muted);">{{ description }}</p>
    <b-button v-if="actionText" :variant="actionVariant || 'primary'" @click="$emit('action')">
      <b-icon v-if="actionIcon" :icon="actionIcon" class="mr-1"/>
      {{ actionText }}
    </b-button>
  </div>
</template>

<script>
export default {
  name: 'EmptyState',
  props: {
    icon: { type: String, default: 'inbox' },
    title: { type: String, required: true },
    description: { type: String, default: '' },
    actionText: { type: String, default: '' },
    actionIcon: { type: String, default: '' },
    actionVariant: { type: String, default: 'primary' }
  }
}
</script>

<style scoped>
.empty-state {
  max-width: 400px;
  margin: 0 auto;
}
</style>